import React from 'react'
import Heading from '../Heading'

import { motion } from "framer-motion";
import { Community_voice } from '../../Data/E_Offer';
const Voice = () => {
     const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                duration: 0.8
            }
        }
    };
  return (
        <motion.section 
            className="main-lwbl bg-[#F9FAFB] pt-16 pb-16 px-[0.5rem] overflow-hidden"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={containerVariants}
        >
           <Heading subHeading={"What Our Community Stands For"}
             heading={"A Place Where Every Voice Belongs"}
             detail={"Our community is designed to offer support at every stage of artistic growth. We foster dialogue, empower curiosity, and provide a welcoming, uplifting environment where creators can explore new ideas without fear of judgment. Every interaction reinforces our values of Learning, Love, and Light."}
           />

           <div className='flex flex-wrap justify-center items-center gap-[20px] mt-[3rem]'>
              {Community_voice.map((data,index)=>(
                 <div
        className="group relative w-[350px] xs:w-[100%] h-[280px] flex flex-col items-center justify-center text-center gap-[1rem] rounded-2xl px-[0.1rem] py-[1rem] 
          transition-all duration-500 hover:scale-[1.04] 
          hover:-translate-y-2 hover:shadow-xl"
        style={{
          background:
            "linear-gradient(29deg, rgba(0, 240, 251, 1) 0%, rgba(255,255,255,1) 50%, rgba(0, 240, 251, 1) 100%)",
        }}
      >
        <img src={data.icon} alt={data.title} width={'50px'} height={'50px'}/>
        <h2
          className="font-cinzel text-[25px] pt-2 pb-2 font-medium 
            transition-all duration-500 group-hover:tracking-wide"
        >
          {data.title}
        </h2>
         <p  className='text-[18px]'>
            {data.description}
         </p>

       
      </div>
              ))}
           </div>
       </motion.section>
  )
}

export default Voice
